import request from '@/utils/request'

const orderAbnormal = {
  name: 'orderAbnormal',
  state: {
    orderAbnormalDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_orderAbnormal_DETAIL_LOADING: (state, data) => {
      state.isorderAbnormalDetailLoading = data
    },
    SET_MODULES_orderAbnormal_DETAIL_DATA: (state, data) => {
      state.orderAbnormalDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryorderAbnormalDetailData({ commit }, id) {
      commit('SET_IS_MODULES_orderAbnormal_DETAIL_LOADING', true)
      commit('SET_MODULES_orderAbnormal_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/orderAbnormal/orderAbnormalDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_orderAbnormal_DETAIL_LOADING', false)
          commit('SET_MODULES_orderAbnormal_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_orderAbnormal_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetorderAbnormalDetailData({ commit }) {
      commit('SET_MODULES_orderAbnormal_DETAIL_DATA', {})
    },
    setorderAbnormalDetailData({ commit }, data) {
      commit('SET_MODULES_orderAbnormal_DETAIL_DATA', data)
    }
  }
}

export default orderAbnormal
